// SPDX-License-Identifier: AGPL-3.0-or-later

import type {Channel} from '@app/features/channel/models/Channel';
import {DataMenuRenderer} from '@app/features/ui/action_menu/DataMenuRenderer';
import {useDMMenuData} from '@app/features/ui/action_menu/items/DMMenuData';
import {MuteDMMenuItem} from '@app/features/ui/action_menu/items/DMMenuItems';
import {MenuGroup} from '@app/features/ui/action_menu/MenuGroup';
import type {User} from '@app/features/user/models/User';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';

interface DMContextMenuProps {
	channel: Channel;
	recipient?: User | null;
	onClose: () => void;
}
export const DMContextMenu: React.FC<DMContextMenuProps> = observer(({channel, recipient, onClose}) => {
	const {t} = useLingui();
	const {groups} = useDMMenuData(channel, recipient, {
		onClose,
	});
	const excludeLabels = useMemo(() => [t`Mute Conversation`, t`Unmute Conversation`], [t]);
	return (
		<>
			<DataMenuRenderer groups={groups} excludeLabels={excludeLabels} />
			<MenuGroup>
				<MuteDMMenuItem channel={channel} onClose={onClose} />
			</MenuGroup>
		</>
	);
});
